import { ShapeType, BShape } from './BShape';
import { NumPair } from '../../Misc/Utils';
import { ObjectType } from '../ObjectTypeEnum';

export class BRect extends BShape{

    protected readonly TYPE = ObjectType.RECT;
    
    constructor(centre: NumPair, wh: NumPair, frameRange : NumPair){
        super(centre, ShapeType.RECTANGLE, frameRange);
        this.setWH(wh);
    }

    protected drawShape(canvasCtx : CanvasRenderingContext2D): void{
        canvasCtx.fillRect(-this.wh[0]/2,-this.wh[1]/2,this.wh[0],this.wh[1]);
        canvasCtx.strokeRect(-this.wh[0]/2,-this.wh[1]/2,this.wh[0],this.wh[1]);
    }

    public clone() : BRect{
        var dupObj : BRect = new BRect(this.getCentre(), this.getWH(), this.getFrameRange());
        super.duplicate(dupObj);
        return dupObj;
    }

}